import { REHYDRATE } from 'redux-persist';
import { LOGGED_OUT } from 'actions/types/user';
export const initialState = {
    investWalkthrough: undefined,
    showNotificationsWalkThrough: false,
    hasSeenNotificationsWalkThrough: false,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            const { walkthrough } = action.payload || {};
            if (walkthrough) {
                return {
                    ...state,
                    ...walkthrough,
                    investWalkthrough: undefined,
                };
            }
            return {
                ...state,
                investWalkthrough: undefined,
            };
        }
        case 'SET_INVEST_WALKTHROUGH_STATUS': {
            return {
                ...state,
                investWalkthrough: {
                    ...state.investWalkthrough,
                    step: 0,
                    status: action.payload.status,
                    isInOnboarding: action.payload.isInOnboarding,
                },
            };
        }
        case 'SET_INVEST_PORTFOLIO_INFO': {
            return {
                ...state,
                investWalkthrough: {
                    ...state.investWalkthrough,
                    info: action.payload,
                },
            };
        }
        case 'SET_INVEST_WALKTHROUGH_STEP': {
            return {
                ...state,
                investWalkthrough: {
                    ...state.investWalkthrough,
                    status: 'in-progress',
                    step: action.payload.step,
                },
            };
        }
        case 'SET_SHOW_NOTIFICATIONS_WALKTHROUGH': {
            return {
                ...state,
                showNotificationsWalkThrough: action.payload,
            };
        }
        case 'SET_HAS_SEEN_NOTIFICATIONS_WALKTHROUGH': {
            return {
                ...state,
                hasSeenNotificationsWalkThrough: action.payload,
            };
        }
        case LOGGED_OUT: {
            return initialState;
        }
        default:
            return state;
    }
};
export default reducer;
